module.exports = __webpack_public_path__ + "static/media/Leopard869_4c.9e7d9a08.svg";